import React from 'react'
import { ProtectedLink, CONTACTS } from '../../Components/ProtectedContact/ProtectedContact.jsx'

export const Footer = () => {
    return (
        <footer>
            <div className="footer-grid">
                <p className="footer-title" onClick={() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }}>Instrumental Dufour</p>
                <p className="footer-slogan">Providing magnetic compass services and certificates since 1939</p>
                <div className="footer-info-cont">
                    <div className="footer-info">
                        <span><i className="fa fa-phone "></i><ProtectedLink value={CONTACTS.technical1} placeholder="+54 9 11 ···· ····" /></span>
                        <span><i className="fa fa-envelope "></i><ProtectedLink value={CONTACTS.email} type="mailto" placeholder="Show email" target="_blank" rel="noreferrer" /></span>
                    </div>
                </div>
            </div>
            <div className='footer-terms'>
                <a href="terms-and-conditions">Terms & Conditions</a>
                <a href="policy">Policy</a>
            </div>
            <p className="made-by">Copyright {new Date().getFullYear()} <i>•</i><a className="made-by"
                href="https://www.linkedin.com/in/franco-ortega-48838123b/" target="_blank" rel="noreferrer">By Fran Ortega</a></p>
        </footer>
    )
}
